import moment from 'moment';

export default function TableConfig(getColumnSearchProps) {
  function hhss(cell, row, key) {
    return moment.utc(row[key] * 1000).format('HH:mm:ss');
  }

  function status(cell) {
    switch (cell) {
      case 0: return 'Создан и находится в изначальной очереди';
      case 1: return 'Вызван на обработку';
      case 2: return 'В процессе обработки';
      case 5: return 'Переведён в новую очередь';
      case 6: return 'Ожидание решения';
      case 7: return 'Возвращён в очередь';
      case 8: return 'Ручная обработка диспетчером';
      case 9: return 'Удален из-за наступления нового дня (талон по какой-то причине просуществовал до ночи в системе)';
      case 11: return 'Переведен на рабочее место';
      default: return null;
    }
  }

  return {
    columns: [
      {
        dataIndex: 'number',
        title: 'Номер',
        fixed: 'left',
        width: 100,
        ...getColumnSearchProps('number', 'номер'),
      },
      {
        dataIndex: 'queueName',
        title: 'Наименование очереди',
        fixed: 'left',
        width: 200,
        ...getColumnSearchProps('queueName', 'наименование очереди'),
      },
      {
        dataIndex: 'status',
        title: 'Статус',
        fixed: 'left',
        width: 180,
        render: status,
        filters: [
          {
            text: 'Создан и находится в изначальной очереди',
            value: 0,
          },
          {
            text: 'Вызван на обработку',
            value: 1,
          },
          {
            text: 'В процессе обработки',
            value: 2,
          },
          {
            text: 'Переведён в новую очередь',
            value: 5,
          },
          {
            text: 'Ожидание решения',
            value: 6,
          },
          {
            text: 'Возвращён в очередь',
            value: 7,
          },
          {
            text: 'Ручная обработка диспетчером',
            value: 8,
          },
          {
            text: 'Удален из-за наступления нового дня (талон по какой-то причине просуществовал до ночи в системе)',
            value: 9,
          },
          {
            text: 'Переведен на рабочее место',
            value: 11,
          },
          {
            text: 'Начато решение вопроса',
            value: 12,
          },
          {
            text: 'Завершено решение вопроса',
            value: 13,
          },
        ],

        onFilter: (value, record) => record.status === value,
      },
      {
        title: 'Время ожидания',
        children: [
          {
            dataIndex: 'totalwait', // 'totalwait' all 0 in response
            title: 'Фактическое',
            width: 140,
            render: (cell, row) => (
              <span
                style={{

                  fontWeight: 'bold',
                  // eslint-disable-next-line no-nested-ternary
                  color: row.totalwait <= row.queueMaxWaitTime ? 'black' : (row.totalwait <= row.queueMaxWaitTime + 60 ? '#f90' : '#f00'),
                }}
              >
                {hhss(cell, row, 'totalwait')}
              </span>
            ),
            sorter: (a, b) => a.totalwait - b.totalwait,
          },
          {
            dataIndex: 'queueMaxWaitTime', // 'totalwait' all 0 in response
            title: 'Регламентное',
            width: 140,
            render: (cell, row) => hhss(cell, row, 'queueMaxWaitTime'),
            sorter: (a, b) => a.queueMaxWaitTime - b.queueMaxWaitTime,
          },
        ],
      },
      {
        title: 'Время обслуживания',
        children: [
          {
            dataIndex: 'procforsecs', // 'totalwait' all 0 in response
            title: 'Фактическое',
            width: 140,
            render: (cell, row) => (
              <span
                style={{
                  fontWeight: 'bold',
                  // eslint-disable-next-line no-nested-ternary
                  color: row.procforsecs <= row.queueMaxServiceTime ? 'black' : (row.procforsecs <= row.queueMaxServiceTime + 60 ? '#f90' : '#f00'),
                }}
              >
                {hhss(cell, row, 'procforsecs')}
              </span>
            ),
            sorter: (a, b) => a.procforsecs - b.procforsecs,
          },
          {
            dataIndex: 'queueMaxServiceTime', // 'totalwait' all 0 in response
            title: 'Регламентное',
            width: 140,
            render: (cell, row) => hhss(cell, row, 'queueMaxServiceTime'),
            sorter: (a, b) => a.queueMaxServiceTime - b.queueMaxServiceTime,
          },
        ],
      },
      {
        dataIndex: 'createdOn',
        title: 'Время создания',
        sorter: {
          compare: (a, b) => moment(a.createdOn, "YYYY.MM.DD HH:mm:ss'") - moment(b.createdOn, 'YYYY.MM.DD HH:mm:ss'),
        },
        width: 200,
      },
      {
        dataIndex: 'first_start_time',
        title: 'Время вызова',
        render: (cell) => {
          if (cell === '01.01.2000 01:01:01') return '';
          return cell && (moment(cell, 'YYYY.MM.DD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss'));
        },
        sorter: {
          compare: (a, b) => moment(a.first_start_time, "YYYY.MM.DD HH:mm:ss'") - moment(b.first_start_time, 'YYYY.MM.DD HH:mm:ss'),
        },
        width: 200,
      },
    ],
  };
}
